import usePageSEO from '@/hooks/usePageSEO';
import { useLanguage } from '@/contexts/LanguageContext';
import PageLayout from '@/components/feature/PageLayout';
import SustainabilityHero from './components/SustainabilityHero';
import SustainabilityProblem from './components/SustainabilityProblem';
import SustainabilitySolution from './components/SustainabilitySolution';
import SustainabilityImpact from './components/SustainabilityImpact';
import SustainabilityBusiness from './components/SustainabilityBusiness';
import SustainabilityCTA from './components/SustainabilityCTA';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://www.juuliang.com';

export default function Sustainability() {
  const { lang } = useLanguage();

  usePageSEO({
    title: {
      zh: '永續與碳效益｜聚量應用材料 — 廢棄塑膠再生 · ESG · 淨零碳排 · 循環經濟',
      en: 'Sustainability & Carbon Impact | PolyQ Applied Materials — Plastic Waste Recycling · ESG · Net-Zero Carbon · Circular Economy',
      ja: 'サステナビリティと炭素効果 | 聚量応用材料 — 廃プラスチック再生・ESG・ネットゼロカーボン・サーキュラーエコノミー',
    },
    description: {
      zh: '聚量以 PQernel® 技術，將廢棄塑膠轉化為可追蹤、可計算碳效益的循環材料，協助企業實現 ESG 目標、降低碳足跡，推動淨零碳排與低碳材料發展。',
      en: 'PolyQ uses PQernel® technology to transform waste plastics into traceable, carbon-benefit-calculable circular materials, helping enterprises achieve ESG goals, reduce carbon footprint, and drive net-zero carbon and low-carbon material development.',
      ja: '聚量はPQernel®技術により廃プラスチックを追跡可能・炭素効果計算可能なサーキュラー材料へと転換し、企業がESG目標達成・カーボンフットプリント削減・ネットゼロカーボンと低炭素材料開発を推進できるよう支援します。',
    },
    keywords: {
      zh: '永續, 碳效益, ESG, 淨零碳排, 循環經濟, 廢棄塑膠再生, 碳足跡, 低碳材料, 企業永續, 聚量應用材料, PQernel',
      en: 'sustainability, carbon impact, ESG, net-zero carbon, circular economy, plastic waste recycling, carbon footprint, low-carbon materials, corporate sustainability, PolyQ Applied Materials, PQernel',
      ja: 'サステナビリティ, 炭素効果, ESG, ネットゼロカーボン, サーキュラーエコノミー, 廃プラスチック再生, カーボンフットプリント, 低炭素材料, 企業サステナビリティ, 聚量応用材料, PQernel',
    },
    path: '/sustainability',
    jsonLd: {
      '@type': 'WebPage',
      name: (lang === 'en' ? 'Sustainability & Carbon Impact' : lang === 'ja' ? 'サステナビリティと炭素効果' : '永續與碳效益'),
      url: siteUrl + '/sustainability',
      description: (lang === 'en'
        ? 'PolyQ uses PQernel® technology to transform waste plastics into traceable, carbon-benefit-calculable circular materials, helping enterprises achieve ESG goals and net-zero carbon targets.'
        : lang === 'ja'
          ? '聚量はPQernel®技術により廃プラスチックを追跡可能・炭素効果計算可能なサーキュラー材料へと転換します。'
          : '聚量以 PQernel® 技術，將廢棄塑膠轉化為可追蹤、可計算碳效益的循環材料，協助企業實現 ESG 目標與淨零碳排。'),
    },
  });

  return (
    <PageLayout>
      <SustainabilityHero />
      <SustainabilityProblem />
      <SustainabilitySolution />
      <SustainabilityImpact />
      <SustainabilityBusiness />
      <SustainabilityCTA />
    </PageLayout>
  );
}